import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";

import { getKey, MODULE_KEYS } from "../../api/api.keys";
import { useRequestProcessor } from "../../hooks/useRequestProcessors";
import { useParams } from "react-router-dom";
import { GetNotificationById } from "../../api/api.service";
import { hasData } from "../../utils/commonUtils";
import { LoaderFallbackUI } from "../../components/LoaderFallbackUI";
import HeaderWithBackButton from "../../components/HeaderWithBackButton/HeaderWithBackButton";
import { CustomText } from "../../components/CustomText";
import { APP_ROUTES } from "../../helpers/routeHelpers";
import SubscriptionStatus from "../../constants/SubscriptionStatus";
import { formatTime12Hour, monthYear } from "../../utils/dateUtils";
import { dateTimeFormat } from "../../utils/dateFormatUtils";
import { NoticationType } from "../../constants";

const Detail = () => {
    const history = useHistory();
    let { notificationID } = useParams();

    let { useFetch } = useRequestProcessor();

    const { data, isLoading, isFetching } = useFetch(
        getKey([MODULE_KEYS.USER_MANAGEMENT_DETAILS], { notificationID }),
        async ({ signal }) =>
            await GetNotificationById({
                Id: notificationID
            })
    );

    if (isFetching || isLoading || !hasData(data)) {
        return (
            <div style={{ height: "70vh" }}>
                <LoaderFallbackUI isLoader={isFetching} className={"h-100"} />
            </div>
        );
    }

    const handleBackClick = () => {
        history.push(APP_ROUTES.NOTIFICATION_MANAGEMENT);
    };

    return (
        <div className="page-content">
            <Helmet>
                <title>User Management Details</title>
            </Helmet>
            <HeaderWithBackButton title="View Notification" onBackClick={handleBackClick} />
            <Card className="" style={{ borderRadius: "20px" }}>
                <CardBody>
                    <Row className="my-3">
                        <Col md={3}>
                            <CustomText
                                titleClass="label-classes"
                                description={data?.title}
                                title={"Title"}
                                descClass="desc-classes"
                            />
                        </Col>
                        <Col md={3}>
                            <CustomText
                                titleClass="label-classes"
                                description={NoticationType.getDisplayTextKey(data?.type) || "-"}
                                title={"Notification Type"}
                                descClass="desc-classes"
                            />
                        </Col>
                        <Col md={3}>
                            <CustomText
                                titleClass="label-classes"
                                description={
                                    monthYear(dateTimeFormat.appDateFormat, data.scheduledAt) || "-"
                                }
                                title={"Schedule Date"}
                                descClass="desc-classes"
                            />
                        </Col>
                        <Col md={3}>
                            <CustomText
                                titleClass="label-classes"
                                description={formatTime12Hour(data.scheduledAt)}
                                title={"Schedule Time"}
                                descClass="desc-classes"
                            />
                        </Col>
                    </Row>
                    <Row className="my-3">
                        <Col md={3}>
                            <CustomText
                                titleClass="label-classes"
                                description={
                                    SubscriptionStatus.getDisplayTextKey(data?.tierType) || "-"
                                }
                                title={"User Group"}
                                descClass={`status-common-class ${SubscriptionStatus.getLabelClass(
                                    data?.tierType
                                )}`}
                            />
                        </Col>
                    </Row>

                    <Row className="my-3">
                        <Col md="12">
                            <CustomText
                                titleClass="label-classes"
                                description={data?.content}
                                title={"Notification Message"}
                                descClass="desc-classes"
                            />
                        </Col>
                    </Row>

                    <Row className="my-2">
                        <Col md="12" className="mb-3 mx-4">
                            <div className={`label-classes mb-2`}>{"Age Group"}</div>
                            <div className="d-flex flex-row gap-2">
                                {data.appNotificationAgeBrackets.map((ageBracket, ind) => (
                                    <div className="d-flex flex-row age-group" key={ind}>
                                        {ageBracket?.ageBracket.endAge
                                            ? `${ageBracket?.ageBracket.startAge} -
                                                        ${ageBracket?.ageBracket.endAge}`
                                            : `${ageBracket?.ageBracket.startAge}+`}
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </div>
    );
};

export default Detail;
